//#region src/duplicate_item_merge_mode.ts
var DuplicateItemMergeMode = /* @__PURE__ */ function(DuplicateItemMergeMode) {
	DuplicateItemMergeMode["None"] = "none";
	DuplicateItemMergeMode["Scanned"] = "scanned";
	DuplicateItemMergeMode["ScannedAndSimple"] = "scanned-and-simple";
	return DuplicateItemMergeMode;
}(DuplicateItemMergeMode || {});
//#endregion
export { DuplicateItemMergeMode };

//# sourceMappingURL=duplicate_item_merge_mode.js.map